import Modal from "react-bootstrap/Modal";

import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import branchSchema from "../../../validations/Branch";
import { apiEditBranch } from "../../../api/master";
import { apiCity, apiState } from "../../../api/stateAndCity";
import { inputOnlyNumber } from "../../../utils";
import config from "../../../config";

function BranchEdit(props) {
  const [stateValue, setStateValue] = useState([]);
  const [city, setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);

  async function getStateAndCity() {
    await apiState().then((result) => setStateValue(result.data.data.list));
    await apiCity().then((result) => setCity(result?.data?.data.list));
  }

  useEffect(function () {
    getStateAndCity();
  }, []);

  const branchFormik = useFormik({
    initialValues: {
      branch_id: props.id?.branch_id,
      branch_name: props.id?.branch_name,
      branch_address: props.id?.branch_address,
      // state_id: props.id?.state_id,
      // city_id: props.id?.city_id,
      // pincode: props.id?.pincode,
      tally_godown: props.id?.tally_godown,
      voucher_type: props.id?.voucher_type,
      sales_ledger: props.id?.sales_ledger,
      credit_note_godown: props.id?.credit_note_godown,
      credit_note_voucher_type: props.id?.credit_note_voucher_type,
      credit_note_ledger: props.id?.credit_note_ledger,
      vat_ledger: props?.id.vat_ledger,
      purchase_vat_ledger: props?.id?.purchase_vat_ledger,
      purchase_godown: props.id?.purchase_godown,
      purchase_ledger: props.id?.purchase_ledger,
      purchase_voucher_type: props.id?.purchase_voucher_type,
      auto_approve: props?.id?.auto_approve ? 1 : 0,
      default_print_type: props?.id?.default_print_type || "",
      expense_voucher_type: props?.id?.expense_voucher_type || "",
      income_voucher_type: props?.id?.income_voucher_type || "",
      cash_ledger: props?.id?.cash_ledger || "",
      stock_voucher_type: props?.id?.stock_voucher_type || "",
    },
    validationSchema: branchSchema.validateBranchEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      values = {
        branch_address: values.branch_address,
        branch_id: Number(values.branch_id),
        branch_name: values.branch_name,
        // city_id: Number(values.city_id),
        // pincode: Number(values.pincode),
        // state_id: Number(values.state_id),
        tally_godown: values.tally_godown,
        voucher_type: values.voucher_type,
        sales_ledger: values.sales_ledger,
        credit_note_godown: values.credit_note_godown,
        credit_note_voucher_type: values.credit_note_voucher_type,
        credit_note_ledger: values.credit_note_ledger,
        vat_ledger: values.vat_ledger,
        purchase_vat_ledger: values.purchase_vat_ledger,
        purchase_godown: values.purchase_godown,
        purchase_ledger: values.purchase_ledger,
        purchase_voucher_type: values.purchase_voucher_type,
        auto_approve: values.auto_approve,
        default_print_type: values.default_print_type,
        expense_voucher_type: values.expense_voucher_type,
        income_voucher_type: values.income_voucher_type,
        cash_ledger: values.cash_ledger,
        stock_voucher_type: values.stock_voucher_type,
      };
      setIsSubmit(true);
      await apiEditBranch(values)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  const stateListMap = stateValue?.flatMap((el) => {
    return {
      value: el?.state_id,
      label: el.name,
    };
  });

  let filterCityName = city?.filter(
    (el) => Number(el?.state_id) === Number(branchFormik.values.state_id),
  );

  const cityListMap = filterCityName?.flatMap((el) => {
    return {
      value: el?.city_id,
      label: el.city,
    };
  });

  useEffect(function () { }, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Branch
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={branchFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="branch_name">
              Branch Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="branch_name"
              {...branchFormik.getFieldProps("branch_name")}
            />
            {branchFormik.errors.branch_name && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.branch_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="branch_address">Branch Address</label>
            <textarea
              type="text"
              maxLength={100}
              className="form-control"
              id="branch_address"
              {...branchFormik.getFieldProps("branch_address")}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="state_id">
              State <span className="text-danger">*</span>
            </label>
            <select
              name="select"
              className="form-select"
              id="state_id"
              {...branchFormik.getFieldProps("state_id")}
            >
              <option hidden>Select...</option>
              {stateListMap?.map((list) => (
                <option value={list.value}>{list.label}</option>
              ))}
            </select>
            {branchFormik.errors.state_id && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.state_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="city_id">
              City <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="city_id"
              {...branchFormik.getFieldProps("city_id")}
            >
              <option hidden>Select...</option>
              {cityListMap?.map((list) => (
                <option value={list.value}>{list.label}</option>
              ))}
            </select>
            {branchFormik.errors.city_id && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.city_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="pincode">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onKeyDown={inputOnlyNumber}
              // minLength={5}
              maxLength={9}
              className="form-control"
              id="pincode"
              {...branchFormik.getFieldProps("pincode")}
            />
            {branchFormik.errors.pincode && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.pincode}
              </div>
            ) : null}
          </div> */}
          <div className="col-md-6">
            <label htmlFor="tally_godown">Tally Godown (Challan)</label>
            <input
              type="text"
              className="form-control"
              id="tally_godown"
              {...branchFormik.getFieldProps("tally_godown")}
            />
            {branchFormik.errors.tally_godown && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.tally_godown}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="voucher_type">Voucher Type (Challan)</label>
            <input
              type="text"
              className="form-control"
              id="voucher_type"
              {...branchFormik.getFieldProps("voucher_type")}
            />
            {branchFormik.errors.voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.voucher_type}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="sales_ledger">Sales Ledger (Challan)</label>
            <input
              type="text"
              className="form-control"
              id="sales_ledger"
              {...branchFormik.getFieldProps("sales_ledger")}
            />
            {branchFormik.errors.sales_ledger && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.sales_ledger}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="vat_ledger">Vat Ledger (Challan)</label>
            <input
              type="text"
              className="form-control"
              id="vat_ledger"
              {...branchFormik.getFieldProps("vat_ledger")}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_godown"> Tally Godown (Purchase)</label>
            <input
              type="text"
              className="form-control"
              id="purchase_godown"
              {...branchFormik.getFieldProps("purchase_godown")}
            />
            {branchFormik.errors.purchase_godown && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.purchase_godown}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_voucher_type">
              {" "}
              Voucher Type (Purchase)
            </label>
            <input
              type="text"
              className="form-control"
              id="purchase_voucher_type"
              {...branchFormik.getFieldProps("purchase_voucher_type")}
            />
            {branchFormik.errors.purchase_voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.purchase_voucher_type}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_ledger"> Ledger (Purchase)</label>
            <input
              type="text"
              className="form-control"
              id="purchase_ledger"
              {...branchFormik.getFieldProps("purchase_ledger")}
            />
            {branchFormik.errors.purchase_ledger && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.purchase_ledger}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_vat_ledger">Vat Ledger (Purchase)</label>
            <input
              type="text"
              className="form-control"
              id="purchase_vat_ledger"
              {...branchFormik.getFieldProps("purchase_vat_ledger")}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_godown">
              {" "}
              Tally Godown ( Challan Return)
            </label>
            <input
              type="text"
              className="form-control"
              id="credit_note_godown"
              {...branchFormik.getFieldProps("credit_note_godown")}
            />
            {branchFormik.errors.credit_note_godown && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.credit_note_godown}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_voucher_type">
              Voucher Type (Challan Return)
            </label>
            <input
              type="text"
              className="form-control"
              id="credit_note_voucher_type"
              {...branchFormik.getFieldProps("credit_note_voucher_type")}
            />
            {branchFormik.errors.credit_note_voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.credit_note_voucher_type}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_ledger">Ledger (Challan Return)</label>
            <input
              type="text"
              className="form-control"
              id="credit_note_ledger"
              {...branchFormik.getFieldProps("credit_note_ledger")}
            />
            {branchFormik.errors.credit_note_ledger && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.credit_note_ledger}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="expense_voucher_type">Expense Voucher Type</label>
            <input
              type="text"
              className="form-control"
              id="expense_voucher_type"
              {...branchFormik.getFieldProps("expense_voucher_type")}
            />
            {branchFormik.errors.expense_voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.expense_voucher_type}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="income_voucher_type">Income Voucher Type</label>
            <input
              type="text"
              className="form-control"
              id="income_voucher_type"
              {...branchFormik.getFieldProps("income_voucher_type")}
            />
            {branchFormik.errors.income_voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.income_voucher_type}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="cash_ledger">Cash Ledger</label>
            <input
              type="text"
              className="form-control"
              id="cash_ledger"
              {...branchFormik.getFieldProps("cash_ledger")}
            />
            {branchFormik.errors.cash_ledger && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.cash_ledger}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="stock_voucher_type">Stock Voucher Type</label>
            <input
              type="text"
              className="form-control"
              id="stock_voucher_type"
              {...branchFormik.getFieldProps("stock_voucher_type")}
            />
            {branchFormik.errors.stock_voucher_type && shownew != true ? (
              <div className="text-danger small">
                {branchFormik.errors.stock_voucher_type}
              </div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="auto_approve">Auto Approve Transaction</label>
            <select
              className="form-select"
              name="auto_approve"
              value={branchFormik.values.auto_approve}
              onChange={(e) => {
                branchFormik.setFieldValue("auto_approve", e.target.value);
              }}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="1">YES</option>
              <option value="0">NO</option>
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="default_print_type">Default Print Type</label>
            <select
              className="form-select"
              name="default_print_type"
              value={branchFormik.values.default_print_type}
              onChange={(e) => {
                branchFormik.setFieldValue("default_print_type", e.target.value);
              }}
            >
              <option value="" hidden>
                Select
              </option>
              {config.challanPrintOptions.map((opt) => (
                <option key={opt.key} value={opt.key}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${error ? "danger" : "success"
                  } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                float: "right",
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    branchFormik.resetForm();
                    setShownew(false);
                    setSuccess("");
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default BranchEdit;
